import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { font } from "../constants/font";

export const LabelInput = styled.div.attrs({ type: "text" })`
  max-width: 100%;
  width: ${(props) => props.width || "100%"};
  border-radius: 8px;
  padding: 8px;
  // margin: 14px 0 8px;
  height: 40px;
  font: ${font.normalBase};
  color: ${font.spanGrey};
  margin-bottom: 0px;
  padding-left: ${(props) => (props.paddingLeft ? "6px" : "0")};
  border: 1px solid ${(props) => props.theme.paymentBorderColor};
  &:focus {
    outline: 0px;
    box-shadow: none;
    border-color: ${(props) => props.theme.hoverBorderColor};
  }
  &:hover {
    border-color: ${(props) => props.theme.hoverBorderColor};
  }
  ::placeholder {
    font: ${font.normalBase};
    color: ${(props) => props.theme.placeholderColor};
  }
`;
const WrapperInput = styled.div`
  width: ${(props)=> props.width}
  position: relative;
`;
const InputImage = styled.img`
  position: absolute;
  left: 10px;
  top: 21.5px;
`;

const PaymentInput = ({
  width,
  placeholder,
  onChange,
  icon,
  onFocus,
  onBlur,
  paddingLeft,
  id
}) => {
  return (
    <WrapperInput width={width}>
      <LabelInput
        id={id}
        placeholder={placeholder}
        onChange={onChange}
        width={width}
        icon={icon}
        onFocus={onFocus}
        onBlur={onBlur}
        paddingLeft={paddingLeft}
      />
      <InputImage src={icon} />
    </WrapperInput>
  );
};

PaymentInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.string,
  icon: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  paddingLeft: PropTypes.bool,
  id: PropTypes.string,
};
export default PaymentInput;
